import { useProfile } from '@ninetailed/experience.js-next';
import Button from 'components/button-new';
import Sheet from 'components/sheet';
import { useConfig } from 'config';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCookieStore } from 'stores/cookie';
import { ShopId } from '../../constants/shop';
import { EventName, trackEvent } from '../../utils/tracking';

const ShopSwitcher: React.FC = () => {
  const ran = useRef(false);
  const [showBanner, setBannerVisibility] = useState<boolean | string>(false);
  const { cookies, updateCookie } = useCookieStore();
  const { profile } = useProfile();
  const { frontendUrl, shopId } = useConfig();

  useEffect(() => {
    if (cookies && !cookies.dismissedCountryOverlay && ran.current === false) {
      ran.current = true;

      const countryOfOrigin = profile?.location?.countryCode || 'DE';

      if (
        (shopId === ShopId.CH &&
          (countryOfOrigin === 'DE' || countryOfOrigin === 'AT')) ||
        (shopId === ShopId.DE && countryOfOrigin === 'CH')
      ) {
        setBannerVisibility(countryOfOrigin);
      } else {
        const date = new Date();
        date.setDate(date.getDate() + 14);

        updateCookie('dismissedCountryOverlay', 'true', {
          expires: date,
          path: '/',
        });
      }
    }
  }, [cookies, profile?.location?.countryCode, shopId, updateCookie]);

  const handleClose = useCallback(() => {
    trackEvent(EventName.CountryModalDismissed);
    const date = new Date();
    date.setDate(date.getDate() + 14);

    updateCookie('dismissedCountryOverlay', 'true', {
      expires: date,
      path: '/',
    });
    setBannerVisibility(false);
  }, [updateCookie]);

  return (
    <Sheet isOpen={!!showBanner} onClose={handleClose}>
      <div className="px-4 pb-6 pt-2">
        <p className="text-lg font-medium">
          <FormattedMessage id={`common:shop-switcher:title`} />
        </p>

        <div className="flex flex-col gap-4 pt-3 text-sm text-text-secondary">
          <p>
            <FormattedMessage id={`common:shop-switcher:${shopId}:text`} />
          </p>

          <Button
            size="large"
            href={frontendUrl}
            onClick={() => {
              trackEvent(EventName.CountryModalClicked, {
                attributes: {
                  targetShop: showBanner,
                },
              });
            }}
          >
            <FormattedMessage id={`common:shop-switcher:${shopId}:button`} />
          </Button>

          <Button layout="outline" size="large" onClick={handleClose}>
            <FormattedMessage
              id={`common:shop-switcher:${shopId}:button-stay`}
            />
          </Button>
        </div>
      </div>
    </Sheet>
  );
};

export default ShopSwitcher;
